module.exports = __webpack_public_path__ + "media/images/landing/icon-secure-data-720dd0a00db3db9318e7f87b4d3792b5.svg";